import { Keyword, List, Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Err, Result } from "@siteimprove/alfa-result";
import { Longhand } from "../longhand.js";
const { either } = Parser;
/**
 * @internal
 */
export const parseFigure = Keyword.parse("lining-nums", "oldstyle-nums");
/**
 * @internal
 */
export const parseSpacing = Keyword.parse("proportional-nums", "tabular-nums");
/**
 * @internal
 */
export const parseFraction = Keyword.parse("diagonal-fractions", "stacked-fractions");
const parseNumeric = (input) => {
    let figure;
    let spacing;
    let fraction;
    let ordinal;
    let slashed;
    while (true) {
        for (const [remainder] of Token.parseWhitespace(input)) {
            input = remainder;
        }
        if (figure === undefined) {
            const result = parseFigure(input);
            if (result.isOk()) {
                [input, figure] = result.get();
                continue;
            }
        }
        if (spacing === undefined) {
            const result = parseSpacing(input);
            if (result.isOk()) {
                [input, spacing] = result.get();
                continue;
            }
        }
        if (fraction === undefined) {
            const result = parseFraction(input);
            if (result.isOk()) {
                [input, fraction] = result.get();
                continue;
            }
        }
        if (ordinal === undefined) {
            const result = Keyword.parse("ordinal")(input);
            if (result.isOk()) {
                [input, ordinal] = result.get();
                continue;
            }
        }
        if (slashed === undefined) {
            const result = Keyword.parse("slashed-zero")(input);
            if (result.isOk()) {
                [input, slashed] = result.get();
                continue;
            }
        }
        break;
    }
    if (figure === undefined &&
        spacing === undefined &&
        fraction === undefined &&
        ordinal === undefined &&
        slashed === undefined) {
        return Err.of("At least one numeric value must be provided");
    }
    return Result.of([
        input,
        List.of([figure, spacing, fraction, ordinal, slashed].filter((value) => value !== undefined), " "),
    ]);
};
const parse = either(Keyword.parse("normal"), parseNumeric);
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-variant-numeric}
 * @internal
 */
export default Longhand.of(Keyword.of("normal"), parse, (numeric) => numeric, { inherits: true });
//# sourceMappingURL=font-variant-numeric.js.map